import { useRef, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Banknote, Landmark, Pencil, Camera, CheckCircle2, Search } from "lucide-react";
import { toast } from "sonner";
import { Q, toB64, fotoUrl } from "./util";

const PALETA = ["from-emerald-50 border-emerald-200", "from-sky-50 border-sky-200", "from-lime-50 border-lime-200", "from-rose-50 border-rose-200",
  "from-violet-50 border-violet-200", "from-amber-50 border-amber-200", "from-cyan-50 border-cyan-200", "from-orange-50 border-orange-200"];

export const CajaCard = ({ c, idx = 0, fecha, cerrado, onSaved }) => {
  const [edit, setEdit] = useState(false);
  const [val, setVal] = useState(0);
  const ref = useRef(null);
  const tid = c.caja.toLowerCase().replace(/[^a-z]+/g, "-");
  const save = async (body) => {
    try { await api.put("/mi-dinero/ciudad/caja", { fecha, caja: c.caja, ...body }); setEdit(false); onSaved(); }
    catch (e) { toast.error(formatApiError(e)); }
  };
  const ok = c.verificado !== null && Math.abs(c.diferencia) < 0.01;
  const Icon = c.tipo === "efectivo" ? Banknote : Landmark;
  return (
    <div className={`rounded-2xl border-2 bg-gradient-to-br to-white p-3 flex gap-3 ${PALETA[idx % PALETA.length]}`} data-testid={`caja-${tid}`}>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 font-black text-sm"><Icon className="w-5 h-5" />{c.caja}</div>
        <div className="text-2xl font-black mt-0.5"><Q v={c.sistema} /></div>
        <div className="text-xs mt-1 flex items-center gap-1">Verificado:
          {edit ? (
            <>
              <input type="number" step="0.01" value={val} onChange={(e) => setVal(e.target.value)} className="w-24 border rounded px-1" data-testid={`caja-${tid}-input`} />
              <button className="text-violet-700 font-bold" onClick={() => save({ verificado: Number(val) })} data-testid={`caja-${tid}-guardar`}>OK</button>
            </>
          ) : (
            <>
              <b className="text-violet-700">{c.verificado === null ? "—" : <Q v={c.verificado} />}</b>
              {!cerrado && <button onClick={() => { setVal(c.verificado ?? c.sistema); setEdit(true); }} className="border rounded p-0.5" data-testid={`caja-${tid}-editar`}><Pencil className="w-3 h-3" /></button>}
            </>
          )}
        </div>
        <div className="text-xs">Diferencia: <b className={c.diferencia ? "text-red-600" : "text-emerald-700"} data-testid={`caja-${tid}-dif`}>{c.diferencia === null ? "—" : <Q v={c.diferencia} />}</b></div>
      </div>
      <div className="relative w-20 h-20 rounded-lg border bg-white overflow-hidden shrink-0">
        {c.foto ? <a href={fotoUrl(c.foto)} target="_blank" rel="noreferrer"><img src={fotoUrl(c.foto)} alt="" className="w-full h-full object-cover" /><Search className="absolute bottom-1 right-1 w-5 h-5 bg-zinc-900 text-white rounded-full p-0.5" /></a>
          : <button disabled={cerrado} onClick={() => ref.current?.click()} className="w-full h-full flex flex-col items-center justify-center text-[10px] text-zinc-500" data-testid={`caja-${tid}-foto`}><Camera className="w-5 h-5" />Foto</button>}
        {ok && <CheckCircle2 className="absolute top-1 right-1 w-5 h-5 text-emerald-600 bg-white rounded-full" />}
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={async (e) => { const f = e.target.files?.[0]; if (f) save({ foto_base64: await toB64(f) }); }} />
      </div>
    </div>
  );
};
